import { templateForViewId, viewIdKind, wallIdOfView } from "@gooner/shared";

/**
 * The last Infinite Scroll / wall the front door played, remembered per tab
 * (Casey 2026-10-07 AM #1 — logo from Browse forgot the mode and landed a fresh draw).
 *
 * sessionStorage: this visit's choice, not a cross-device preference. Blocked storage
 * reads as "no last view" and drops the write — same manners as the other `gp:` keys.
 */
const KEY = "gp:last-home-view";

/**
 * Whether a `?view=` names something the pending screen (`/`, `/screen`) will play: a
 * temporary copy, a wall, an Infinite Scroll, or a real quick setup. A SAVED id is not
 * on the list — that is a library view, which plays on a device, not on a claimable
 * page. The one rule for both readers: PendingScreen decides what to open with it, and
 * `rememberHomeView` refuses to store anything it would then answer with "Couldn't open
 * this view" (a signed-in device can be playing a saved view; Home must not point there).
 */
export function canOpenOnPendingScreen(viewId: string): boolean {
  return (
    viewId.startsWith("t_") ||
    wallIdOfView(viewId) !== null ||
    viewIdKind(viewId) === "infinity" ||
    templateForViewId(viewId) !== null
  );
}

export function rememberHomeView(viewId: string): void {
  if (!viewId || !canOpenOnPendingScreen(viewId)) return;
  try {
    sessionStorage.setItem(KEY, viewId);
  } catch {
    /* quota or blocked */
  }
}

export function readHomeView(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/** Logo / Menu Home target — last mode when we have one, else bare `/`. */
export function homeHref(): string {
  const viewId = readHomeView();
  if (!viewId) return "/";
  return `/?view=${encodeURIComponent(viewId)}`;
}
